



















































































































































import {Component, Prop} from 'vue-property-decorator'
import NetworkTag from '@/components/NetworkTag.vue'
import neonWalletIcon from '@/assets/img/neonwallet.png'
import neolineIcon from '@/assets/img/wallets/neoline.png'
import onegateIcon from '@/assets/img/wallets/onegate.jpg'
import metamaskIcon from '@/assets/img/wallets/metamask.svg'
import walletConnectIcon from '@/assets/img/walletconnect.svg'
import {WalletPlatform} from '@/enums/WalletPlatform'
import {$} from '@/facade'
import {BrowserHelper} from '@/helpers/BrowserHelper'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import ConnectWalletMenu from '@/components/walletConnection/ConnectWalletMenu.vue'
import ConnectWalletOption from '@/components/walletConnection/ConnectWalletOption.vue'
import {NetworkNamespace} from '@/enums/NetworkNamespace'
import {
  isNeoLineAvailableInBrowser,
  isNeoLineInAppBrowser,
} from '@/store/model/wallets/connection/NeoLineConnection'
import {isMetaMaskAvailableInBrowser} from '@/store/model/wallets/connection/MetaMaskConnection'
import ConnectWalletNetworkSelect from '@/components/walletConnection/ConnectWalletNetworkSelect.vue'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import {siteNetwork} from '@/helpers/NetworkModeRegistry'
import {isWalletPlatformEnabled} from '@/config/WalletAvailabilityConfig'

@Component({
  components: {
    ConnectWalletMenu,
    ConnectWalletOption,
    ConnectWalletNetworkSelect,
    NetworkTag,
  },
  computed: {
    BrowserHelper() {
      return BrowserHelper
    },
    $() {
      return $
    },
    WalletPlatform() {
      return WalletPlatform
    },
    NetworkNamespace() {
      return NetworkNamespace
    },
  },
})
export default class ConnectWalletChooseWallet extends MixinScreenSize {
  @Prop({type: Function, required: true}) onSelectWallet!: (
    // eslint-disable-next-line no-unused-vars
    namespace: NetworkNamespace,
    // eslint-disable-next-line no-unused-vars
    wallet?: WalletPlatform
  ) => Promise<void>
  @Prop({type: String, required: true})
  networkNamespace!: NetworkNamespace
  @Prop({type: String, default: undefined}) targetNetwork?: TWalletNetwork

  isN3Active =
    isNeoLineInAppBrowser() ||
    (this.networkNamespace === NetworkNamespace.n3 &&
      this.hasSessionToConnect('n3'))

  neonWalletIcon = neonWalletIcon
  neolineIcon = neolineIcon
  onegateIcon = onegateIcon
  metamaskIcon = metamaskIcon
  walletConnectIcon = walletConnectIcon

  isNeoLineDownloadAvailable = true
  isMetaMaskDownloadAvailable = !isMetaMaskAvailableInBrowser()

  hasSessionToConnect(walletImplementation: 'n3' | 'neoX'): boolean {
    const state = this.$store.state.walletAdapter

    return state.networksInUse[walletImplementation].some(
      (network: TWalletNetwork) =>
        !state.sessions[walletImplementation][network].address
    )
  }

  get activeImplementation(): 'n3' | 'neoX' {
    return this.isN3Active ? 'n3' : 'neoX'
  }

  get availableNetworks(): TWalletNetwork[] {
    return this.$store.state.walletAdapter.networksInUse[
      this.activeImplementation
    ]
  }

  get selectedNetwork(): TWalletNetwork {
    const preferred = this.targetNetwork ?? siteNetwork()

    return this.availableNetworks.includes(preferred)
      ? preferred
      : this.availableNetworks[0]
  }

  get isNeoLineInApp() {
    return isNeoLineInAppBrowser()
  }

  get showNeolineOption() {
    if (this.isMobile) {
      return true
    }

    return BrowserHelper.checkIfChrome() || BrowserHelper.checkIfFirefox()
  }

  get showNeolineNeoXOption() {
    return (
      isWalletPlatformEnabled(WalletPlatform.NEOLINE, 'neoX') &&
      !this.isMobile &&
      (BrowserHelper.checkIfChrome() || BrowserHelper.checkIfFirefox())
    )
  }

  get showMetaMaskOption() {
    return (
      isWalletPlatformEnabled(WalletPlatform.METAMASK, 'neoX') &&
      (!this.isMobile || isMetaMaskAvailableInBrowser())
    )
  }

  get neonDeeplinkSubtitle() {
    const key = this.isMobile
      ? 'components.ConnectWalletChooseWallet.neonDeeplinkMobileSubtitle'
      : 'components.ConnectWalletChooseWallet.neonDeeplinkDesktopSubtitle'

    return this.$translate(key)
  }

  mounted() {
    this.refreshNeoLineDownloadState()

    window.addEventListener(
      'Neo.DapiProvider.ready',
      this.refreshNeoLineDownloadState
    )

    window.addEventListener(
      'eip6963:announceProvider',
      this.refreshNeoLineDownloadState
    )

    window.addEventListener(
      'eip6963:announceProvider',
      this.refreshMetaMaskDownloadState
    )

    window.dispatchEvent(new Event('eip6963:requestProvider'))

    this.$watch(
      () => [
        this.isMobile,
        this.isN3Active,
        this.selectedNetwork,
        this.$store.state.walletAdapter.sessions[this.activeImplementation][
          this.selectedNetwork
        ].walletsStatus[WalletPlatform.NEOLINE],
      ],
      () => this.refreshNeoLineDownloadState()
    )
  }

  beforeDestroy() {
    window.removeEventListener(
      'Neo.DapiProvider.ready',
      this.refreshNeoLineDownloadState
    )

    window.removeEventListener(
      'eip6963:announceProvider',
      this.refreshNeoLineDownloadState
    )

    window.removeEventListener(
      'eip6963:announceProvider',
      this.refreshMetaMaskDownloadState
    )
  }

  refreshMetaMaskDownloadState() {
    this.isMetaMaskDownloadAvailable = !isMetaMaskAvailableInBrowser()
  }

  isNeolineDetectedInBrowser() {
    return isNeoLineAvailableInBrowser(this.activeImplementation)
  }

  async refreshNeoLineDownloadState() {
    // Probing NeoLine boots its dAPI; on a chain where it is turned off there is
    // no option to enable, so the probe would only wake the wallet for nothing.
    if (
      !isWalletPlatformEnabled(
        WalletPlatform.NEOLINE,
        this.activeImplementation
      )
    ) {
      this.isNeoLineDownloadAvailable = false
      return
    }

    if (this.isMobile) {
      this.isNeoLineDownloadAvailable = false
      return
    }

    if (this.isNeolineDetectedInBrowser()) {
      this.isNeoLineDownloadAvailable = false
      return
    }

    try {
      this.isNeoLineDownloadAvailable = !(await this.canUseNeoline())
    } catch (error) {
      console.error('Error checking NeoLine availability:', error)
      this.isNeoLineDownloadAvailable = true
    }
  }

  async canUseNeoline() {
    return this.activeImplementation === 'neoX'
      ? await $.walletAdapter.canUseXWallet(
          WalletPlatform.NEOLINE,
          this.selectedNetwork
        )
      : await $.walletAdapter.canUseN3Wallet(
          WalletPlatform.NEOLINE,
          this.selectedNetwork
        )
  }
}
